<template>
    <h1>Help!</h1>
</template>

<script>
export default {
    name: "PartitonHelp",
}
</script>

<style>

</style>
